import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {WorkOrderType} from '../../../../models/workOrderType.model';
import {WorkOrderTypeService} from '../../../../services/work-order-type.service';
import {WorkOrderService} from '../../../../services/work-order.service';
import {WorkOrder} from '../../../../models/workOrder.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {Piece} from '../../../../models/piece.model';
import { FormControl, FormGroup } from '@angular/forms';
import { FicheInterventionService } from 'app/services/fiche-intervention.service';
import {forEach} from "lodash-es";

@Component({
    selector: 'app-fiche-intervention-work-orders',
    templateUrl: './fiche-intervention-work-orders.component.html',
})
export class FicheInterventionWorkOrdersComponent implements OnInit {
    @Input() ficheIntervention: FicheIntervention;
    @Input() pieces: Piece[] = [];
    @Input() workOrderTypes: WorkOrderType[] = [];
    @Input() workOrders: WorkOrder[] = [];

    @Output() editWorkOrder = new EventEmitter<WorkOrder>();
    @Output() refreshWorkOrder = new EventEmitter<WorkOrder>();

    openChevron = [];

    workOrdersForm = {};

    isUpdating = false;

    get isAdmin(): boolean {
        return true;
    }

    constructor(
        private workOrderService: WorkOrderService,
        private ficheInterventionService: FicheInterventionService
    ) {
    }

    ngOnInit(): void {
        this.setGroupWorkOrders();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['workOrders']) {
            this.setGroupWorkOrders();
        }
    }

    workOrderTypesAutofill(workOrder): WorkOrderType[] {
        const searchText = workOrder?.value?.type;

        if (!searchText || workOrder?.value?.originalType == searchText) {
            return this.workOrderTypes;
        }

        return this.workOrderTypes.filter(workOrderType => workOrderType.name.toLowerCase().includes(searchText?.toLowerCase()));
    }

    setGroupWorkOrders() {
        this.workOrdersForm = {};
        const sortedWorkOrders = this.workOrders.sort(
            (a, b) => a.type > b.type ? 1 : -1
        );

        forEach(sortedWorkOrders, (workOrder) => {
            const pieceName = this.getPieceNom(workOrder.piece_id);
            const nomNiveau = this.getPieceNomNiveau(workOrder.piece_id);

            const key = `${pieceName} - ${nomNiveau}`;
            if (!this.workOrdersForm[key]) {
                this.workOrdersForm[key] = [];
            }

            this.workOrdersForm[key].push(new FormGroup({
                id: new FormControl(workOrder.id),
                type: new FormControl(workOrder.type),
                piece_id: new FormControl(workOrder.piece_id),
                fiche_intervention_id: new FormControl(this.ficheIntervention.id),
                dimension: new FormControl(workOrder?.data['dimension']),
                originalType: new FormControl(workOrder.type),
            }));
        });
    }

    fetchWorkOrders() {
        this.workOrderService.getWorkOrders(this.ficheIntervention.id).subscribe(
            (response) => {
                this.workOrders = response;
                this.setGroupWorkOrders();
            }
        );
    }

    getPieceNomNiveau(pieceId: number): string {
        const piece = this.pieces.find(p => p.id === pieceId);
        return piece ? piece.nom_niveau : 'Inconnue';
    }

    getPieceNom(piece_id: number): string {
        const piece: Piece = this.pieces.find((p: Piece) => p.id == piece_id);
        return piece ? piece.nom_piece : '';
    }

    delete(workOrderForm: FormGroup): void {
        const workOrder = workOrderForm.value;
        this.workOrderService.delete(workOrder).subscribe(() => {
            this.refreshWorkOrder.emit();
        });
    }

    updateWorkOrder(workOrder) {
        const form = new FormGroup({
            id: new FormControl(workOrder?.value?.id),
            type: new FormControl(workOrder?.value?.type),
            piece_id: new FormControl(workOrder?.value?.piece_id),
            fiche_intervention_id: new FormControl(this.ficheIntervention.id),
            data: new FormGroup({
                dimension: new FormControl(workOrder?.value?.dimension),
            }),
        });

        this.ficheInterventionService.storeOrUpdateWorkOrder(form.value).subscribe(() => {
            this.fetchWorkOrders();
        });

    }

    get workOrderPiece() {
        return Object.keys(this.workOrdersForm);
    }

    workOrderGroupForPiece(pieceName) {
        return this.workOrdersForm[pieceName];
    }

    getWorkOrderFormForId(workOrderGroup, id) {
        return workOrderGroup[id];
    }

    getWorkOrdersInGroup(workOrderGroup) {
        return Object.keys(workOrderGroup);
    }

    toggleChevron(index: any): void {
        if (this.chevronIsOpen(index)) {
            delete this.openChevron[index];
        } else {
            this.openChevron[index] = true;
        }
    }

    chevronIsOpen(index: number|string): boolean {
        return typeof this.openChevron[index] !== 'undefined';
    }

    workOrderType(workOrder) {
        return workOrder.type === 'Enlevé' ? workOrder.data.type : workOrder.type;
    }

    quickAdd(pieceName) {
        const keyPieces = pieceName.split(' - ');
        pieceName = '';
        let piece_id= null;

        const nomPiece = keyPieces[0];
        let nomNiveau = keyPieces[1];
        if (nomNiveau === 'Inconnue') {
            nomNiveau = '';
        }

        forEach(keyPieces, (keyPiece) => {
            pieceName = keyPiece;
            piece_id = this.pieces.find(p => p.nom_niveau === nomNiveau && p.nom_piece === pieceName)?.id;

            if (piece_id) {
                return false;
            }
        });

        if (!piece_id) {
            return;
        }

        const form = new FormGroup({
            id: new FormControl(),
            type: new FormControl(),
            piece_id: new FormControl(piece_id),
            fiche_intervention_id: new FormControl(this.ficheIntervention.id),
            data: new FormGroup({}),
        });

        this.updateWorkOrder(form);
    }
}
